import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

const JourneyOutlined = forwardRef<SVGSVGElement, BusinessIconImageProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <path d="M11.9999 7.86809C13.1597 7.86809 14.0999 6.92789 14.0999 5.76809C14.0999 4.60829 13.1597 3.66809 11.9999 3.66809C10.8401 3.66809 9.8999 4.60829 9.8999 5.76809C9.8999 6.92789 10.8401 7.86809 11.9999 7.86809Z" stroke="currentColor" strokeWidth={strokeWidth ?? "1.5"} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.4999 19.0953C7.6597 19.0953 8.5999 18.1551 8.5999 16.9953C8.5999 15.8355 7.6597 14.8953 6.4999 14.8953C5.3401 14.8953 4.3999 15.8355 4.3999 16.9953C4.3999 18.1551 5.3401 19.0953 6.4999 19.0953Z" stroke="currentColor" strokeWidth={strokeWidth ?? "1.5"} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17.4999 19.0953C18.6597 19.0953 19.5999 18.1551 19.5999 16.9953C19.5999 15.8355 18.6597 14.8953 17.4999 14.8953C16.3401 14.8953 15.3999 15.8355 15.3999 16.9953C15.3999 18.1551 16.3401 19.0953 17.4999 19.0953Z" stroke="currentColor" strokeWidth={strokeWidth ?? "1.5"} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 8.11414L12 11.5" stroke="currentColor" strokeWidth={strokeWidth ?? "1.5"} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6.5 14.8953V11.5H17.5V14.8953" stroke="currentColor" strokeWidth={strokeWidth ?? "1.5"} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
);

JourneyOutlined.displayName = 'JourneyOutlined';

export default JourneyOutlined;
